/**
 * CONFIG
 * true  → anima solo la primera vez
 * false → anima cada vez que entra en viewport
 */
const COUNT_ANIMATE_ONCE = false;



function parseCountString(str) {
  const s = String(str).trim();
  const m = s.match(/^([^0-9\-.,]*)([-+]?\d+(?:[.,]\d+)?)(.*)$/);
  if (!m) return { prefix: '', value: 0, suffix: '', decimals: 0 };

  const prefix = m[1] ?? '';
  const numRaw = (m[2] ?? '').replace(',', '.');
  const suffix = (m[3] ?? '').trim();
  const decimals = (numRaw.split('.')[1] || '').length;

  let value = Number(numRaw);
  if (Number.isNaN(value)) value = 0;

  return { prefix, value, suffix, decimals };
}

function formatCount({ prefix, value, suffix, decimals }) {
  const fixed = decimals > 0 ? value.toFixed(decimals) : Math.round(value);
  return `${prefix}${fixed}${suffix}`;
}

function setToZero(el) {
  const original = el.dataset.count;
  const parsed = parseCountString(original);
  el.textContent = formatCount({ ...parsed, value: 0 });
}

function animateCount(el, duration = 1400) {

  const original = el.dataset.count;
  const parsed = parseCountString(original);
  const start = 0;
  const end = parsed.value;
  const startTime = performance.now();

  const step = (now) => {

    const progress = Math.min((now - startTime) / duration, 1);
    const eased = 1 - Math.pow(1 - progress, 3);
    const current = start + (end - start) * eased;

    el.textContent = formatCount({
      ...parsed,
      value: current
    });

    if (progress < 1) {
      requestAnimationFrame(step);
    } else {
      el.textContent = formatCount({ ...parsed, value: end });
    }
  };

  requestAnimationFrame(step);
}

export const MyCount = {
  init() {

    const numbers = document.querySelectorAll('.number[data-count]');
    if (!numbers.length) return;

    numbers.forEach(setToZero);

    const observer = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {

        const el = entry.target;

        if (entry.isIntersecting) {

          if (COUNT_ANIMATE_ONCE && el.dataset.done) return;

          animateCount(el);

          el.dataset.done = true;

        } else {

          if (!COUNT_ANIMATE_ONCE) {
            setToZero(el);
          }

        }

      });

    }, {
      threshold: 0.35
    });

    numbers.forEach(el => observer.observe(el));
  }
};